import { createContext, Dispatch, SetStateAction } from 'react';
import { TSceneComponent } from '@treedis/tour-loader';
import { Tag } from '@/_models/Tag';
import { AddWorkflow, NoteAction, TNote, TNoteMessage } from './types';
import { NoteIntegration, SidebarStep } from './enums';
import { Tour } from '@/_models/Tour';
import { User } from '@/_models/User';

type NotesContext = {
  tags: Tag[];
  isOpen: boolean;
  closeDrawer: () => void;
  openDrawer: () => void;
  showCaseTemp: any;
  iframe: any;
  tour: Tour;
  initialThreads: TNote[];
  appState: any;
  addThreadToSpace: (thread: any) => Promise<any>;
  showcase: any;
  showcaseTag: any;
  selectedThreadProp: any;
  incrementNewMessagesCount: () => void;
  decrementNewMessagesCount: () => void;
  resetNewMessagesCount: () => void;
  removeThreadFromSpace: (thread: any) => Promise<void>;
  toggleThreadVisibility: (thread: any, isVisible: boolean) => void;
  hideElements: (data: any) => Promise<void>;
  getLocation: () => string;
  isRtl: boolean;
  moveToTag: (sid: string) => void;

  sidebarStep: SidebarStep;
  setSidebarStep: (sidebar: SidebarStep) => void;

  collaborators: User[];

  isGuest: boolean;
  setIsGuest: (isGuest: boolean) => void;

  userId: number | null;
  setUserId: (userId: number | null) => void;

  newThread: any;
  setNewThread: (thread: any) => void;

  integration: NoteIntegration;

  isTourAdmin: boolean;

  isBoardOpen: boolean;
  setIsBoardOpen: (open: boolean) => void;

  mediaUrls: { src: string; flaggedToDelete: boolean }[];
  setMediaUrls: (urls: { src: string; flaggedToDelete: boolean }[]) => void;

  newThreadMessages: { [key: number]: number };
  setNewThreadMessages: (
    messages:
      | { [key: number]: number }
      | ((prev: { [key: number]: number }) => { [key: number]: number }),
  ) => void;

  controls: { current: TSceneComponent | null };
  tagNode: { current: any };
  inputNodeComponent: { current: any };
  attachToCursor: { current: any };
  normal: { current: any };
  clickListenerRef: { current: any };
  contentDrawerRef: { current: any };
  refUserId: { current: number | undefined };
  initialThreadsRef: { current: any[] };

  updateMessages: (thread: any, messageToUpdate: any) => any;

  handleCompleteNote: (noteId: number, noteFromAnotherUser?: any) => void;

  currentAction: NoteAction | null;
  setCurrentAction: Dispatch<SetStateAction<NoteAction | null>>;

  noteToEdit: { note: TNote; message?: TNoteMessage } | null;
  setNoteToEdit: Dispatch<SetStateAction<{ note: TNote; message?: TNoteMessage } | null>>;

  addingWorkflow: AddWorkflow | null;
  setAddingWorkflow: Dispatch<SetStateAction<AddWorkflow | null>>;

  handleMoveToNote: (thread: TNote) => void;

  handleQuitAdding: () => Promise<void>;

  selectedNoteTag: Tag | null;
  unselectNoteTag: () => void;

  selectedFilterTag: Tag | null;
  setSelectedFilterTag: Dispatch<SetStateAction<Tag | null>>;
};

export const NotesContext = createContext<NotesContext>(null);
